import { useNavigate } from "react-router-dom";

export default function ErrorPage() {
  const navigate = useNavigate();

  return (
    <section className="error-page-ctr w-[90vw] max-w-[900px] mx-auto">
      <h1>Error 404 not found</h1>
      <button onClick={() => navigate("/")}>Return to home</button>
    </section>
  );
}
